/* @flow */
import { createAction } from 'redux-actions';
import camelCase from 'lodash/camelCase';
import { namespaceActions } from './index';

type ProcessedActionsT = {
  actions: {
    [string]: ActionCreatorT,
  },
  actionTypes: {
    [string]: string,
  },
};

/**
 * Accepts namespace and action names list and returns object with 2 attrs:
 * actionTypes: list of namespaced action types
 * actions: action creators for each type
 */
export default function actionsPreprocessor(namespace: string, names: Array<string>): ProcessedActionsT {
  const actionTypes = namespaceActions(namespace, names);
  const actions = names.reduce((acc, name) => {
    acc[camelCase(name)] = createAction(actionTypes[name]);
    return acc;
  }, {});

  return { actions, actionTypes };
}
